// Me store entryfile
import mutations from './mutations';
import actions from './actions';

// Initial state
const state = {
  categoryIndex: 0,
};

export default {
  state,
  actions,
  mutations,
};
